import React, { useState, useContext } from 'react';
import { PropTypes } from 'prop-types';

import ChatContext from '../../context/ChatContext';
import ChatMessage from '../../Model/ChatMessage';
import MessageInput from '../MessageInput';
import {
  ControlsContainer,
  StyledButtonContainer,
  StyledPrimaryButton,
  StyledSecondaryButton,
  StyledDialog,
} from './styles';

import texts from './texts.json';

const EditMessageModal = ({
  message, isOpen, onClose,
}) => {
  const {
    authUser,
  } = useContext(ChatContext);

  const {
    text,
  } = message;

  const [newText, setNewText] = useState(text);

  const handleSubmit = async () => {
    await message.editText(newText, authUser.id);
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
      disableEnforceFocus
      disablePortal
      fullWidth
      maxWidth="sm"
    >
      <MessageInput
        text={newText}
        onChange={setNewText}
        isEditMessage
        minRows={5}
        maxRows={10}
      />
      <ControlsContainer>
        <StyledButtonContainer />
        <StyledButtonContainer>
          <StyledSecondaryButton
            onClick={onClose}
            full={false}
          >
            {texts.cancel}
          </StyledSecondaryButton>
          <StyledPrimaryButton
            onClick={handleSubmit}
            disabled={text === newText || newText.trim().length === 0}
            full={false}
          >
            {texts.send}
          </StyledPrimaryButton>
        </StyledButtonContainer>
      </ControlsContainer>
    </StyledDialog>
  );
};

EditMessageModal.propTypes = {
  message: PropTypes.instanceOf(ChatMessage).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditMessageModal;
